import { useEffect, useState, useRef, useCallback } from "react";
import { MainLayout } from "../components/layout/MainLayout";
import { Header } from "../components/layout/Header";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../components/ui/table";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import {
  Search,
  Plus,
  Save,
  Calendar,
  User,
  AlertCircle,
  CheckCircle2,
  TrendingDown,
  Trash2,
  X,
  Zap,
  Package,
  AlertTriangle,
  ArrowLeft,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { cn } from "../lib/utils";
import { retrieveData } from "../LocalConnection/LocalConnection.js";
import {
  get_item_acc_to_department_master_data,
  get_department_with_categories,
  save_update_audit,
  server_post_data,
} from "../ServiceConnection/serviceconnection";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery.js";
import Loader from "../components/layout/Loader.js";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
export default function AuditScreen() {
  const navigate = useNavigate();
  const searchInputRef = useRef(null);
  const suggestionsRef = useRef(null);

  // State management
  const [auditItems, setAuditItems] = useState([]);
  const [auditNotes, setAuditNotes] = useState("");
  const [loading, setLoading] = useState(false);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);

  // Search and items
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchDropdown, setShowSearchDropdown] = useState(false);
  const [selectedSuggestionIndex, setSelectedSuggestionIndex] = useState(0);
  const [masterItemList, setmasterItemList] = useState([]);
  const [justAddedItem, setJustAddedItem] = useState(null);

  // Reason dialog
  const [showReasonDialog, setShowReasonDialog] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [reasonText, setReasonText] = useState("");

  // User info
  const [auditorName, setauditorName] = useState("");
  const auditorId = retrieveData("user_id") || "—";
  const [selectedDepartment, setSelectedDepartment] = useState("Kitchen");
  const [selectedDepartmentID, setSelectedDepartmentID] = useState("0");
  const [selectedDepartmentIndex, setSelectedDepartmentIndex] = useState("0");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState("0");
  const [selectedCategoryID, setSelectedCategoryID] = useState("0");
  const [selectedVendor, setSelectedVendor] = useState("");
  const [selectedVendorID, setSelectedVendorID] = useState("0");
  const [SelectedVendorIndex, setSelectedVendorIndex] = useState("0");
  const [poItems, setPOItems] = useState([]);
  const [categories, setcategories] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [adminName, setadminName] = useState("");
  const [unitTypes, setUnitTypes] = useState([]);

  const handleDepartmentChange = (index) => {
    console.log("Selected department index:", departments[index]);
    setSelectedDepartment(departments[index].department_id);
    setSelectedDepartmentIndex(index);
    setSelectedDepartmentID(departments[index].department_id);
    setSelectedVendor("");
    setSelectedVendorIndex("0");
    setSelectedVendorID("0");
    setSelectedCategory("");
    setSelectedCategoryIndex("0");
    setSelectedCategoryID("0");
    setcategories(departments[index].categories);
    setAuditItems([]);
    setSearchQuery("");
    setShowSuggestions(false);
    item_data_get(departments[index].department_id);
  };

  const auditDate = new Date().toLocaleDateString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });

  // Load master data on mount
  useEffect(() => {
    master_data_get();
  }, []);

  

  // Scroll selected suggestion into view
  useEffect(() => {
    if (suggestionsRef.current && showSearchDropdown) {
      const selectedElement =
        suggestionsRef.current.children[selectedSuggestionIndex];
      if (selectedElement) {
        selectedElement.scrollIntoView({
          block: "nearest",
          behavior: "smooth",
        });
      }
    }
  }, [selectedSuggestionIndex, showSearchDropdown]);


const item_data_get = async (department_id) => {
    setauditorName(retrieveData("admin_name"));
    

    const fd = new FormData();
    fd.append("status", "all");
    fd.append("search", "");
    fd.append("department_id",department_id);

    try {
      const response = await server_post_data(get_item_acc_to_department_master_data, fd);

      if (response.data.error) {
        handleError(response.data.message.data);
      } else {
        const items = response.data.message.items || [];
          console.log("Items fetched:", items);
         setmasterItemList(items || []);
      }
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoaderAdmin(false);
    }
  };

  // Get master data from API
  const master_data_get = async () => {
    setauditorName(retrieveData("admin_name"));
    setshowLoaderAdmin(true);

    const fd = new FormData();
    fd.append("status", "all");
    fd.append("search", "");

    try {
      const response = await server_post_data(get_department_with_categories, fd);

      if (response.data.error) {
        handleError(response.data.message.data);
      } else {
        const departments_dta = response.data.message.data || [];
          console.log("Departments fetched:", departments_dta);
          setDepartments(departments_dta);
        //   const { items } = response.data.message;
        // setmasterItemList(items || []);
          // auto-select first department safely
          if (departments_dta.length > 0) {
            setSelectedDepartment(departments_dta[0].department_name);
            setSelectedDepartmentID(departments_dta[0].primary_id);
            setcategories(departments_dta[0].categories || []);
          }
      }
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoaderAdmin(false);
    }
  };

  // Search items function
  const searchItems = (query) => {
    const lowercaseQuery = query.toLowerCase();
    return masterItemList.filter((item) =>
      item.name.toLowerCase().includes(lowercaseQuery),
    );
  };

  // Get search suggestions
  const searchSuggestions =
    searchQuery.length >= 2 ? searchItems(searchQuery).slice(0, 10) : [];

  // Handle search input change
  const handleSearch = useCallback((query) => {
    setSearchQuery(query);
    setShowSearchDropdown(true);
    setSelectedSuggestionIndex(0);
  }, []);

  // Handle add item
  const handleAddItem = useCallback(
    (item) => {
      const existing = auditItems.find((a) => a.ingredient_id === item.id);
      if (existing) {
        setJustAddedItem(item.id);
        setTimeout(() => setJustAddedItem(null), 1000);
        return;
      }

      const newAuditItem = {
        id: Date.now().toString(),
        itemId: item.id, // ✅ itemId field
        ingredient_id: item.id,
        name: item.name, // ✅ name field
        stock_qty: item.currentStock,
        physical_qty: "",
        unit: item.unit, // ✅ unit field
        unit_id: item.default_unit_id,
        default_unit_id: item.default_unit_id, // ✅ default_unit_id field
        difference: 0,
        type: "No Difference", // ✅ type field (Loss/Gain/No Difference)
        reason: "",
      };

      setAuditItems((prev) => [...prev, newAuditItem]);

      // Show success feedback
      setJustAddedItem(item.id);
      setTimeout(() => setJustAddedItem(null), 1000);

      // Clear search
      setSearchQuery("");
      setShowSearchDropdown(false);
      setSelectedSuggestionIndex(0);

      // Refocus search input
      setTimeout(() => {
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }, 100);
    },
    [auditItems],
  );

  // Keyboard navigation
  const handleKeyDown = useCallback(
    (e) => {
      if (!showSearchDropdown || searchSuggestions.length === 0) return;

      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setSelectedSuggestionIndex((prev) =>
            prev < searchSuggestions.length - 1 ? prev + 1 : prev,
          );
          break;
        case "ArrowUp":
          e.preventDefault();
          setSelectedSuggestionIndex((prev) => (prev > 0 ? prev - 1 : 0));
          break;
        case "Enter":
          e.preventDefault();
          if (searchSuggestions[selectedSuggestionIndex]) {
            handleAddItem(searchSuggestions[selectedSuggestionIndex]);
          }
          break;
        case "Escape":
          e.preventDefault();
          setShowSearchDropdown(false);
          setSearchQuery("");
          setSelectedSuggestionIndex(0);
          break;
        default:
          break;
      }
    },
    [
      showSearchDropdown,
      searchSuggestions,
      selectedSuggestionIndex,
      handleAddItem,
    ],
  );

  // Handle physical quantity change
  const handlePhysicalQtyChange = useCallback((itemId, value) => {
    setAuditItems((prevItems) =>
      prevItems.map((item) => {
        if (item.ingredient_id === itemId) {
          const physicalQty = parseFloat(value) || 0;
          const stockQty = parseFloat(item.stock_qty) || 0;
          const diff = stockQty - physicalQty;

          return {
            ...item,
            physical_qty: value,
            difference: Math.abs(diff),
            type: diff > 0 ? "Loss" : diff < 0 ? "Gain" : "No Difference",
          };
        }
        return item;
      }),
    );
  }, []);

  // Open reason dialog
  const handleOpenReasonDialog = (itemId, currentReason) => {
    setSelectedItemId(itemId);
    setReasonText(currentReason);
    setShowReasonDialog(true);
  };

  // Save reason
  const handleSaveReason = () => {
    setAuditItems((prevItems) =>
      prevItems.map((item) =>
        item.ingredient_id === selectedItemId
          ? { ...item, reason: reasonText }
          : item,
      ),
    );
    setShowReasonDialog(false);
    setReasonText("");
    setSelectedItemId(null);
  };

  // Remove item
  const handleRemoveItem = (itemId) => {
    setAuditItems(auditItems.filter((item) => item.ingredient_id !== itemId));
  };

  // Calculate stats
  const stats = {
    totalItems: auditItems.length,
    totalLoss: auditItems
      .filter((i) => i.type === "Loss")
      .reduce((sum, i) => sum + (parseFloat(i.difference) || 0), 0),
    totalGain: auditItems
      .filter((i) => i.type === "Gain")
      .reduce((sum, i) => sum + (parseFloat(i.difference) || 0), 0),
  };

  // Truncate reason text
  const truncateReason = (text, words = 4) => {
    if (!text) return "";
    const textArray = text.split(" ");
    if (textArray.length > words) {
      return textArray.slice(0, words).join(" ") + "...";
    }
    return text;
  };

  // Get stock display
  const getStockDisplay = (item) => {
    return `${item.currentStock} ${item.unit}`;
  };

  // Get stock badge
  const getStockBadge = (item) => {
    const masterItem = masterItemList.find((m) => m.id === item.ingredient_id);
    if (!masterItem) return null;

    if (masterItem.currentStock <= 0) {
      return (
        <Badge variant="destructive" className="text-[10px]">
          Out
        </Badge>
      );
    } else if (masterItem.currentStock <= masterItem.minStock) {
      return (
        <Badge className="text-[10px] bg-amber-100 text-amber-700 border-amber-300">
          Low
        </Badge>
      );
    }
    return (
      <Badge className="text-[10px] bg-emerald-100 text-emerald-700 border-emerald-300">
        In Stock
      </Badge>
    );
  };

  // Handle submit audit - with proper API data format
  const handleSubmitAudit = async () => {
    if (auditItems.length === 0) {
      alert("Please add at least one audit item");
      return;
    }

    setLoading(true);

    const formattedItems = auditItems.map((item) => {
      // Clean ingredient_id → remove "ING" prefix and convert to number
      let cleanIngredientId = item.ingredient_id;
      if (
        typeof cleanIngredientId === "string" &&
        cleanIngredientId.startsWith("ING")
      ) {
        cleanIngredientId =
          parseInt(cleanIngredientId.replace(/^ING/i, ""), 10) || 0;
      } else {
        cleanIngredientId = parseInt(cleanIngredientId, 10) || 0;
      }

      // Map type to backend-expected difference_type
      let differenceType = "equal";
      if (item.type === "Loss") {
        differenceType = "short";
      } else if (item.type === "Gain") {
        differenceType = "excess";
      }

      return {
        id: item.id, // temporary string id
        itemId: item.itemId, // keep original (with ING if present)
        ingredient_id: cleanIngredientId, // number
        name: item.name,
        adjustment_qty: String(parseFloat(item.physical_qty) || 0), // as string
        unit: item.unit || "",
        default_unit_id: item.default_unit_id || "",
        system_qty: String(parseFloat(item.stock_qty) || 0), // as string
        physical_qty: String(parseFloat(item.physical_qty) || 0), // as string
        difference_qty: String(parseFloat(item.difference) || 0), // as string
        difference_type: differenceType, // "short" / "excess" / "equal"
        reason: item.reason || "",
      };
    });

    const fd = new FormData();
    fd.append("audit_id", "0");
    fd.append("audit_date", new Date().toISOString());
    fd.append("auditor_name", auditorName);
    fd.append("auditor_id", auditorId);
    fd.append("department_id", selectedDepartmentID);
    fd.append("audit_notes", auditNotes);
    fd.append("total_items", auditItems.length);
    fd.append("total_loss", stats.totalLoss);
    fd.append("total_gain", stats.totalGain);

    fd.append("items", JSON.stringify(formattedItems));

    try {
      const response = await server_post_data(save_update_audit, fd);

      if (response.data.error) {
        handleError(response.data.message);
      } else {
        handleSuccess("Success", "Audit submitted successfully!");
        navigate("/audits");
      }
    } catch (error) {
      handleError("network");
    } finally {
      setLoading(false);
    }
  };

  // Get low stock items
  const lowStockItems = masterItemList
    .filter((item) => item.currentStock <= item.minStock)
    .slice(0, 5);

  return (
    <MainLayout>
      <Header
        title="Create Audit"
        subtitle="Fast keyboard-driven workflow → Type, Arrow keys, Enter to add"
      />
      {(showLoaderAdmin || loading) && <Loader />}

      <div className="p-6 space-y-2">
        {/* Header with back button and workflow */}
        <div className="flex items-center justify-between">
          <Button
            variant="ghost"
            onClick={() => navigate("/audits")}
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </Button>
          <div className="flex items-center gap-2 text-xs">
            <span className="px-3 py-1.5 rounded-full bg-primary text-primary-foreground font-medium">
              1. Create
            </span>
            <span className="text-muted-foreground">→</span>
            <span className="px-3 py-1.5 rounded-full bg-muted text-muted-foreground">
              2. View
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Main Content - 3 columns */}
          <div className="lg:col-span-3 space-y-6">
            {/* Header Info */}
            <Card>
              <CardContent className="pt-6">
                <div className="grid grid-cols-3 gap-4">
                  <div className="space-y-2">
                    <Label className="text-xs">Created By</Label>
                    <Input
                      value={auditorName}
                      disabled
                      className="h-9 text-sm bg-muted"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-xs">Date</Label>
                    <Input
                      value={auditDate}
                      disabled
                      className="h-9 text-sm bg-muted"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-xs">Audit ID</Label>
                    <Input
                      value={auditorId}
                      disabled
                      className="h-9 text-sm bg-muted"
                    />
                  </div>
                  <div className="space-y-2">
                                    <Label className="text-xs">Department *</Label>
                                    <Select
                                      value={selectedDepartmentIndex}
                                      onValueChange={handleDepartmentChange}
                                    >
                                      <SelectTrigger className="h-9 text-sm">
                                        <SelectValue />
                                      </SelectTrigger>
                                      <SelectContent>
                                        {departments.map((dept, index) => (
                                          <SelectItem key={index} value={index}>
                                            {dept.department_name}
                                          </SelectItem>
                                        ))}
                                      </SelectContent>
                                    </Select>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* QUICK ADD SECTION - Prominent & Large */}
            <Card className="border-2 border-primary/20">
              <CardHeader className="pb-3">
                <div className="flex items-center gap-2">
                  <Zap className="w-5 h-5 text-primary" />
                  <CardTitle className="text-lg">Quick Add Items</CardTitle>
                </div>
                <CardDescription>
                  Type to search → Use ↑↓ arrows → Press Enter to add
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                {/* Large Search Input */}
                <div className="relative">
                  <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
                  <Input
                    ref={searchInputRef}
                    placeholder="Search items... (Type 2+ characters)"
                    value={searchQuery}
                    onChange={(e) => handleSearch(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onFocus={() =>
                      searchQuery.length >= 2 && setShowSearchDropdown(true)
                    }
                    className="h-12 pl-12 pr-12 text-base border-2 focus:border-primary"
                  />
                  {searchQuery && (
                    <Button
                      variant="ghost"
                      size="sm"
                      className="absolute right-2 top-1/2 -translate-y-1/2 h-8 w-8 p-0"
                      onClick={() => {
                        setSearchQuery("");
                        setShowSearchDropdown(false);
                        setSelectedSuggestionIndex(0);
                        searchInputRef.current?.focus();
                      }}
                    >
                      <X className="w-4 h-4" />
                    </Button>
                  )}
                </div>

                {/* Search Suggestions - Keyboard Navigable */}
                {showSearchDropdown && searchSuggestions.length > 0 && (
                  <div
                    ref={suggestionsRef}
                    className="border-2 border-primary/30 rounded-lg overflow-hidden max-h-[320px] overflow-y-auto bg-card"
                  >
                    {searchSuggestions.map((item, index) => {
                      const isAdded = auditItems.some(
                        (a) => a.ingredient_id === item.id,
                      );
                      const isSelected = index === selectedSuggestionIndex;
                      const isJustAdded = justAddedItem === item.id;
                      const isLowStock = item.currentStock <= item.minStock;
                      const isOutOfStock = item.currentStock <= 0;

                      return (
                        <button
                          key={item.id}
                          className={cn(
                            "w-full px-4 py-3 text-left flex items-center justify-between gap-3 border-b border-border last:border-0 transition-all",
                            isSelected &&
                              "bg-primary/10 border-l-4 border-l-primary",
                            isAdded && "opacity-60 cursor-not-allowed",
                            isJustAdded && "bg-success/20 animate-pulse",
                            !isSelected && !isAdded && "hover:bg-muted/50",
                          )}
                          onClick={() => !isAdded && handleAddItem(item)}
                          disabled={isAdded}
                        >
                          <div className="flex items-center gap-3 flex-1">
                            {isAdded ? (
                              <CheckCircle2 className="w-5 h-5 text-success flex-shrink-0" />
                            ) : (
                              <Plus
                                className={cn(
                                  "w-5 h-5 flex-shrink-0",
                                  isSelected
                                    ? "text-primary"
                                    : "text-muted-foreground",
                                )}
                              />
                            )}
                            <div className="flex-1">
                              <p className="font-semibold text-sm">
                                {item.name}
                              </p>
                              <div className="flex items-center gap-2 mt-0.5">
                                <span className="text-xs text-muted-foreground">
                                  {item.category}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <div className="text-right">
                              <div className="flex items-center gap-1.5">
                                <Package
                                  className={cn(
                                    "w-4 h-4",
                                    isOutOfStock && "text-destructive",
                                    isLowStock &&
                                      !isOutOfStock &&
                                      "text-amber-500",
                                    !isLowStock &&
                                      !isOutOfStock &&
                                      "text-emerald-500",
                                  )}
                                />
                                <span
                                  className={cn(
                                    "text-sm font-bold",
                                    isOutOfStock && "text-destructive",
                                    isLowStock &&
                                      !isOutOfStock &&
                                      "text-amber-600",
                                    !isLowStock &&
                                      !isOutOfStock &&
                                      "text-emerald-600",
                                  )}
                                >
                                  {getStockDisplay(item)}
                                </span>
                              </div>
                            </div>
                            {(isLowStock || isOutOfStock) && (
                              <AlertTriangle
                                className={cn(
                                  "w-4 h-4",
                                  isOutOfStock
                                    ? "text-destructive"
                                    : "text-amber-500",
                                )}
                              />
                            )}
                          </div>
                        </button>
                      );
                    })}
                  </div>
                )}

                {showSearchDropdown &&
                  searchQuery.length >= 2 &&
                  searchSuggestions.length === 0 && (
                    <div className="border-2 border-dashed rounded-lg p-6 text-center">
                      <p className="text-muted-foreground">
                        No items found matching "{searchQuery}"
                      </p>
                    </div>
                  )}

                {/* Help Text */}
                <div className="bg-muted/50 rounded-lg p-3">
                  <p className="text-xs text-muted-foreground flex items-center gap-2">
                    <span className="font-semibold text-foreground">
                      💡 Quick Tips:
                    </span>
                    Use ↑↓ arrows to navigate • Press Enter to add • Esc to
                    close • Auto-focuses after each add
                  </p>
                </div>
              </CardContent>
            </Card>

            {/* Audit Notes */}
            <Card>
              <CardHeader>
                <CardTitle>Audit Notes</CardTitle>
                <CardDescription>
                  Add general notes about this audit (Optional)
                </CardDescription>
              </CardHeader>
              <CardContent>
                <Textarea
                  placeholder="Enter any observations, discrepancies, or notes about this audit..."
                  value={auditNotes}
                  onChange={(e) => setAuditNotes(e.target.value)}
                  rows={4}
                  className="resize-none"
                />
              </CardContent>
            </Card>
          </div>

          {/* Right Sidebar - Summary (Sticky) */}
          <div className="lg:col-span-1">
            <div className="sticky top-6 space-y-4">
              <Card>
                <CardHeader>
                  <CardTitle className="text-base">Audit Summary</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="space-y-3">
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">Total Items</span>
                      <Badge className="bg-primary text-primary-foreground">
                        {stats.totalItems}
                      </Badge>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">Total Loss</span>
                      <span className="text-red-600 font-bold">
                        {stats.totalLoss.toFixed(2)}
                      </span>
                    </div>
                    <div className="flex justify-between text-sm">
                      <span className="text-muted-foreground">Total Gain</span>
                      <span className="text-green-600 font-bold">
                        {stats.totalGain.toFixed(2)}
                      </span>
                    </div>
                  </div>

                  <Button
                    className="w-full gap-2"
                    disabled={auditItems.length === 0 || loading}
                    onClick={handleSubmitAudit}
                  >
                    <Save className="w-4 h-4" />
                    {loading ? "Submitting..." : "Submit Audit"}
                  </Button>
                </CardContent>
              </Card>

              {/* Low Stock Alerts */}
              {lowStockItems.length > 0 && (
                <Card className="border-amber-200 bg-amber-50/50">
                  <CardHeader>
                    <div className="flex items-center gap-2">
                      <AlertTriangle className="w-4 h-4 text-amber-600" />
                      <CardTitle className="text-sm text-amber-900">
                        Low Stock Alert
                      </CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-2">
                      {lowStockItems.map((item) => (
                        <button
                          key={item.id}
                          onClick={() => handleAddItem(item)}
                          className="w-full text-left p-2 rounded hover:bg-amber-100 transition-colors"
                          disabled={auditItems.some(
                            (a) => a.ingredient_id === item.id,
                          )}
                        >
                          <p className="text-xs font-medium text-amber-900">
                            {item.name}
                          </p>
                          <p className="text-[10px] text-amber-700">
                            {getStockDisplay(item)}
                          </p>
                        </button>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              )}
            </div>
          </div>
        </div>

        {/* AUDIT ITEMS TABLE */}
        {auditItems.length > 0 && (
          <Card>
            <CardHeader>
              <div className="flex items-center justify-between">
                <CardTitle className="text-lg">
                  Audit Items ({auditItems.length})
                </CardTitle>
                <Badge variant="outline" className="bg-primary/10 text-primary">
                  {auditItems.length} items added
                </Badge>
              </div>
            </CardHeader>
            <CardContent>
              <div className="rounded-lg border overflow-x-auto">
                <Table>
                  <TableHeader>
                    <TableRow className="bg-muted/50">
                      <TableHead className="text-muted-foreground">
                        Item
                      </TableHead>
                      <TableHead className="text-center text-muted-foreground">
                        Stock
                      </TableHead>
                      <TableHead className="text-center text-muted-foreground">
                        Physical Qty
                      </TableHead>
                      <TableHead className="text-center text-muted-foreground">
                        Difference
                      </TableHead>
                      <TableHead className="text-muted-foreground">
                        Reason (Optional)
                      </TableHead>
                      <TableHead className="text-center text-muted-foreground">
                        Action
                      </TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {auditItems.map((item) => (
                      <TableRow
                        key={item.ingredient_id}
                        className="hover:bg-muted/30"
                      >
                        <TableCell className="font-medium">
                          <div className="flex items-center gap-2">
                            <div>
                              <p className="font-medium">{item.name}</p>
                            </div>
                            {getStockBadge(item)}
                          </div>
                        </TableCell>
                        <TableCell className="text-center">
                          <span className="font-semibold">
                            {item.stock_qty} {item.unit}
                          </span>
                        </TableCell>
                        <TableCell className="text-center">
                          <div className="flex items-center justify-center gap-2">
                            <Input
                              type="number"
                              min="0"
                              step="0.01"
                              value={item.physical_qty}
                              onChange={(e) =>
                                handlePhysicalQtyChange(
                                  item.ingredient_id,
                                  e.target.value,
                                )
                              }
                              placeholder="0"
                              className="w-20 text-center"
                            />
                            <span className="text-sm text-muted-foreground min-w-12">
                              {item.unit}
                            </span>
                          </div>
                        </TableCell>
                        <TableCell className="text-center">
                          <Badge
                            variant="outline"
                            className={cn(
                              "font-semibold",
                              item.type === "Loss"
                                ? "bg-red-100 text-red-700 border-red-300"
                                : item.type === "Gain"
                                  ? "bg-green-100 text-green-700 border-green-300"
                                  : "bg-gray-100 text-gray-700 border-gray-300",
                            )}
                          >
                            {item.difference.toFixed(2)}
                          </Badge>
                        </TableCell>
                        <TableCell>
                          <button
                            onClick={() =>
                              handleOpenReasonDialog(
                                item.ingredient_id,
                                item.reason,
                              )
                            }
                            className="text-sm text-muted-foreground hover:text-foreground truncate max-w-xs"
                          >
                            {item.reason
                              ? truncateReason(item.reason)
                              : "Add reason (optional)"}
                          </button>
                        </TableCell>
                        <TableCell className="text-center">
                          <Button
                            variant="ghost"
                            size="sm"
                            onClick={() => handleRemoveItem(item.ingredient_id)}
                            className="text-destructive hover:text-destructive hover:bg-destructive/10"
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            </CardContent>
          </Card>
        )}
      </div>

      {/* Reason Dialog */}
      <Dialog open={showReasonDialog} onOpenChange={setShowReasonDialog}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle>Add Reason for Discrepancy</DialogTitle>
            <DialogDescription>
              Explain why there is a difference in stock and physical quantity
              (Optional)
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-4">
            <Textarea
              placeholder="Enter reason (e.g., Damaged items, Theft, Miscounting, Expired items, etc.)"
              value={reasonText}
              onChange={(e) => setReasonText(e.target.value)}
              rows={5}
              className="resize-none"
            />
            <div className="text-xs text-muted-foreground">
              When saved, the first few words will be shown in the table. This
              field is optional.
            </div>
          </div>

          <DialogFooter className="gap-2 sm:gap-0">
            <Button
              variant="outline"
              onClick={() => {
                setShowReasonDialog(false);
                setReasonText("");
                setSelectedItemId(null);
              }}
            >
              Cancel
            </Button>
            <Button onClick={handleSaveReason} className="gap-2">
              <Save className="w-4 h-4" />
              Save Reason
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </MainLayout>
  );
}
